
$(function () {
    var $overlay = $('.menu-overlay');
    var $toggle = $('.menu-overlay-toggle');

    function setMenu(open) {
        $overlay.toggleClass('active', open).attr('aria-hidden', open ? 'false' : 'true');
        $toggle.attr({
            'aria-expanded': open ? 'true' : 'false',
            'aria-label': open ? 'Menü schließen' : 'Menü öffnen',
            'title': open ? 'Menü schließen' : 'Menü öffnen'
        });
        $('body').toggleClass('menu-overlay-open', open);
    }

    $toggle.on('click', function (event) {
        event.stopPropagation();
        setMenu(!$overlay.hasClass('active'));
    });

    $('.menu-overlay__close').on('click', function () {
        setMenu(false);
    });

    $overlay.on('click', function (event) {
        event.stopPropagation();
    });

    $(document).on('click', function () {
        setMenu(false);
    });

    $(document).on('keydown', function (event) {
        if (event.key === 'Escape') {
            setMenu(false);
        }
    });
});
